module.exports = __webpack_public_path__ + "static/img/awesome-sink_256.e470a03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/awesome-sink_256.png
// module id = 87T4
// module chunks = 0